import extendedPropertyType from 'owa-service/lib/factory/extendedPropertyType';
import extendedPropertyUri from 'owa-service/lib/factory/extendedPropertyUri';
import { Message } from 'owa-mail-compose-actions';
import { AppendOnSend } from 'owa-addins-core';

export default function setAppendOnSendExtendedPropertiesToMessage(
    appendOnSend: AppendOnSend[],
    message: Message
) {
    if (!message.ExtendedProperty) {
        message.ExtendedProperty = [];
    }
    message.ExtendedProperty.push(
        extendedPropertyType({
            Value: JSON.stringify(appendOnSend),
            ExtendedFieldURI: extendedPropertyUri({
                DistinguishedPropertySetId: 'Common',
                PropertyName: 'AppendOnSend',
                PropertyType: 'String',
            }),
        })
    );
}
